import React, { useMemo } from 'react';
import { useParcoursFormalite } from '@europrocurement/l2d-modules/modules/ParcoursFormalite/provider';
import { SirenRneContext } from './SirenRneContext';

const ParcoursSirenRneProvider: React.FunctionComponent<{ children: React.ReactNode }> = function ({
    children,
}) {
    const { currentSousClient, getCurrentDossier } = useParcoursFormalite();
    const dossier = getCurrentDossier();

    const value = useMemo(() => ({ currentSousClient, dossier }), [currentSousClient, dossier]);

    return <SirenRneContext.Provider value={value}>{children}</SirenRneContext.Provider>;
};

export default ParcoursSirenRneProvider;
